import React from 'react';

export default function Projects() {
  const schemes = [
    { title: "Uttar Pradesh Kaushal Vikas Mission", short: "UPSDM" },
    { title: "Pradhan Mantri Kaushal Vikas Yojana", short: "PMKVY (State-Component)" },
    { title: "Deen Dayal Upadhyay Grameen Kaushalya Yojana", short: "DDU-GKY" },
    { title: "National Rural Livelihood Mission", short: "NRLM" },
    { title: "National Urban Livelihood Mission", short: "NULM" },
    { title: "National Skills Qualification Framework", short: "NSQF" }
  ];

  const footprints = [
    { 
      state: "Uttar Pradesh", 
      agency: "UPSDM / PMKVY / NULM", 
      details: "Comprehensive state-component skilling deployments and urban livelihood operations.",
      badge: "Core Base" 
    },
    { 
      state: "Madhya Pradesh", 
      agency: "MPSSDEGB Partnership", 
      details: "State Skill Development & Employment Generation Board core partnership framework.",
      badge: "Core Partner" 
    },
    { 
      state: "Maharashtra", 
      agency: "MSSDS Skilling Programs", 
      details: "Collaborative implementation of workforce skilling modules under State Skill Development Society.",
      badge: "Active State" 
    },
    { 
      state: "Bihar", 
      agency: "BSDM Strategic Alliances", 
      details: "Targeted skill development training alliances empowering localized youth structures.",
      badge: "Active State" 
    },
    { 
      state: "Rajasthan", 
      agency: "ILD Skill University, Jaipur", 
      details: "Institutional framework alignment for academic-backed vocational excellence structures.",
      badge: "University Aligned" 
    },
    { 
      state: "Punjab", 
      agency: "Dept. of Rural Development & Panchayats", 
      details: "Grassroots action plans targeted at comprehensive rural employment enhancements.",
      badge: "Rural Scope" 
    },
    { 
      state: "Uttarakhand", 
      agency: "UKDWP Project Framework", 
      details: "World Bank funded workforce development initiative focusing on critical technical trades.",
      badge: "World Bank Funded" 
    }
  ];

  return (
    <section id="projects" className="py-4">
      {/* Header Info Banner */}
      <div className="text-center mb-5">
        <div className="d-inline-flex align-items-center gap-2 bg-primary bg-opacity-10 text-primary border border-primary border-opacity-10 rounded-pill px-3 py-1 mb-2">
          <i className="bi bi-globe2 small"></i>
          <span className="small fw-bold text-uppercase tracking-wider">Pan-India Integration</span>
        </div>
        <h2 className="fw-bold display-5 text-dark mb-3">Major Schemes & National Footprint</h2>
        <p className="text-muted mx-auto" style={{ maxWidth: '700px' }}>
          Partnering effectively with the Ministry of Skill Development and Entrepreneurship alongside premier state-level missions to scale high-impact workforce transitions.
        </p>
      </div>

      <div className="row g-4">
        
        {/* Left Column: Schemes Container */}
        <div className="col-lg-5">
          <div 
            className="card border-0 shadow-sm h-100 p-4 text-white position-relative overflow-hidden"
            style={{ background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)', borderRadius: '1rem' }}
          >
            {/* Structural Background Vector Pattern overlay hint */}
            <div className="position-absolute opacity-10 end-0 bottom-0 pointer-events-none translate-x-10 translate-y-10">
              <i className="bi bi-shield-check text-white" style={{ fontSize: '14rem' }}></i>
            </div>

            <div className="card-body position-relative z-1 p-2">
              <div className="d-flex align-items-center gap-3 mb-4">
                <div className="bg-blue bg-opacity-10 rounded-3 p-2.5 text-warning">
                  <i className="bi bi-shield-check fs-4"></i>
                </div>
                <div>
                  <h4 className="fw-bold mb-0 text-white">Central & State Schemes</h4>
                  <small className="text-white-50">Accredited Governance Frameworks</small>
                </div>
              </div>
              
              <div className="d-flex flex-column gap-3">
                {schemes.map((scheme, index) => (
              <div key={index} className="p-3 rounded-3 bg-success bg-opacity-25 border border-success border-opacity-25 hover-lift-light transition-all">
                    <div className="d-flex align-items-start gap-3">
                      <i className="bi bi-check-circle-fill text-warning mt-1 flex-shrink-0"></i>
                      <div className="text-start">
                        <span className="d-block fw-bold text-white small lh-sm">{scheme.title}</span>
                        {scheme.short && <span className="badge bg-white bg-opacity-10 text-warning extra-small font-monospace mt-1.5">{scheme.short}</span>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Footprints Map Grid */}
        <div className="col-lg-7">
          <div className="d-flex align-items-center justify-content-between mb-3 px-1">
            <h4 className="fw-bold text-dark-emphasis mb-0">
              <i className="bi bi-geo-alt text-primary me-2"></i>Regional Implementations
            </h4>
            <span className="text-muted small font-monospace fw-semibold">
              <i className="bi bi-building me-1"></i> {footprints.length} Operating Frameworks
            </span>
          </div>
          
          <div className="row g-3">
            {footprints.map((item, index) => (
              <div className="col-md-6" key={index}>
                <div className="card h-100 bg-white border border-light-subtle shadow-sm hover-footprint transition-all rounded-3">
                  <div className="card-body p-4 d-flex flex-column justify-content-between text-start">
                    <div>
                      <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                        <h6 className="fw-bold text-primary mb-0 fs-5">{item.state}</h6>
                        <span className={`badge ${item.badge === 'Core Base' ? 'bg-danger-subtle text-danger' : item.badge === 'World Bank Funded' ? 'bg-success-subtle text-success' : 'bg-primary-subtle text-primary'} font-monospace extra-small px-2 py-1 rounded`}>
                          {item.badge}
                        </span>
                      </div>
                      
                      <div className="text-dark fw-bold small mb-2 font-sans tracking-wide bg-light p-2 rounded border-start border-2 border-primary border-opacity-50">
                        <i className="bi bi-layers text-secondary me-1.5 small"></i>{item.agency}
                      </div>
                      
                      <p className="text-muted extra-small lh-base mb-0">{item.details}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* Embedded Component Scope Styles */}
      <style>{`
        .transition-all { transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1); }
        .hover-lift-light:hover {
          background-color: rgba(195, 30, 30, 0.09) !important;
          transform: translateX(3px);
        }
        .hover-footprint {
          border: 1px solid rgba(0,0,0,0.06) !important;
        }
        .hover-footprint:hover {
          transform: translateY(-4px);
          background-color: #fafafa !important;
          box-shadow: 0 .5rem 1.5rem rgba(0, 0, 0, 0.05) !important;
          border-color: rgba(13, 110, 253, 0.2) !important;
        }
        .extra-small { font-size: 0.7rem; }
        border-white-syntax-adjust { border-color: rgba(255,255,255,0.1) !important; }
      `}</style>
    </section>
  );
}